module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MC45NDUiIGhlaWdodD0iNDAuOTQ1IiB2aWV3Qm94PSIwIDAgNDAuOTQ1IDQwLjk0NSI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEzNzEuNTYzIC0xMTUuNjc5KSI+PHJlY3QgY2xhc3M9ImEiIHdpZHRoPSI5LjM1MSIgaGVpZ2h0PSI0OC41NTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNzEuNTYzIDEyMi4yOTEpIHJvdGF0ZSgtNDUpIi8+PHJlY3QgY2xhc3M9ImEiIHdpZHRoPSI5LjM1MSIgaGVpZ2h0PSI0OC41NTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0MDUuODk1IDExNS42NzkpIHJvdGF0ZSg0NSkiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/close_icon.svg
// module id = 8p+/
// module chunks = 0